import { Button, Spinner } from '@nextui-org/react'
import { useState } from 'react'
import { Icon } from '@iconify/react'
import { useSocketContextData } from 'src/context/socket'
import { PowerDocsEventsName } from 'src/types/SocketEvents'
import { useNavigate } from 'react-router-dom'
import { useSubscriptionContext } from 'src/context/subscription'
import toast from 'react-hot-toast'
import { PRICES_PROD } from 'src/lib/constants'

export default function Subscribe() {

    const [loading, setLoading] = useState<boolean>(false)
    const { io } = useSocketContextData()
    const navigate = useNavigate()
    const {currentLimitations, getUserSubscription} = useSubscriptionContext()
    const subscribeTo = async (product: 'EXPLORE' | 'EVALUATE' | 'EXECUTE') => {
        if (!currentLimitations?.isFreeTrial && currentLimitations?.freeTrialPackage && !currentLimitations?.hasSubscription) {
            //@ts-ignore
            window.open(PRICES_PROD?.[product], '_blank')
        } else {
            setLoading(true)
            const subscribed = await io.emitWithAck(PowerDocsEventsName.SELECT_FREE_TIER, {
                product,
                token: localStorage.getItem('accessToken'),
            })
            if (subscribed) {
                setTimeout(() => {
                    setLoading(false)
                    toast.success(`🎉 Tada, you can now enjoy 7 free days of your ${product} plan`)
                    getUserSubscription?.()
                    navigate('/')
                }, 2000)
            } else {
                toast.error('There was an error, please try again.')
                setLoading(false)
            }
        }
    }
    return (
        <div className="flex flex-1">
            <div className="flex flex-1 items-center flex-col pt-40">
                <img src={'/img/powerdocs-logo-signet.png'} alt={'logo'} className={'h-[100px] mb-3'} />
                <h1 className={'text-4xl font-medium'}>Subscribe to PowerDocs</h1>
                <h2 className={'text-md font-light text-default-400'}>You can select one of the following plans and enjoy a free 7days trial, no credit card asked and cancel at anytime.</h2>
                {loading && <p className={'gap-2 flex items-center justify-center pt-2'}><Spinner size='sm' /> Selecting your plan...</p>}
                <div className={'flex flex-row gap-4 pt-10'}>
                    <div className={'flex flex-col flex-1 border border-3 rounded-2xl border-default p-4'}>
                        <span className={'text-xs font-bold text-default-400 pb-2'}>EXPLORE</span>
                        <h3 className={'text text-3xl font-bold'}>$ 29</h3>
                        <h4 className={'text text-l font-bold'}>per user per month</h4>
                        <span className={'font-medium text-default-400 text-xs pb-4'}>Free 1-week trial, cancel anytime</span>

                        <span className={'font-medium text-sm'}>Monitor tenders</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Analyze fit & risks</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Create & manage proposals</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> AI-assisted proposal drafting
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> Microsoft Word integrationm
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> Team workspace & audit logs
                            </li>
                        </ul>

                        <Button
                            onClick={() => {
                                // Track payment intent
                                subscribeTo('EXPLORE')
                            }}
                            variant={'solid'}
                            className={'rounded-3xl font-bold text-sm w-fit pl-10 pr-10 self-center mt-4'}
                            color={'secondary'}
                            isDisabled={loading}
                        >
                            {!currentLimitations?.isFreeTrial && currentLimitations?.freeTrialPackage && currentLimitations?.freeTrialPackage === 'EXPLORE' ? 'Continue With EXPLORE' : 'Get Started'}
                        </Button>
                    </div>

                    <div className={'flex flex-col flex-1 border border-3 rounded-2xl border-default p-4'}>
                        <span className={'text-xs font-bold text-default-400 pb-2'}>EVALUATE</span>
                        <h3 className={'text text-3xl font-bold'}>$ 59</h3>
                        <h4 className={'text text-l font-bold'}>per user per month</h4>
                        <span className={'font-medium text-default-400 text-xs pb-4'}>Free 1-week trial, cancel anytime</span>

                        <span className={'font-medium text-sm'}>Monitor tenders</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Analyze fit & risks</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Create & manage proposals</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> AI-assisted proposal drafting
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> Microsoft Word integrationm
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-default'} icon="lucide:x" /> Team workspace & audit logs
                            </li>
                        </ul>

                        <Button
                            onClick={() => {
                                // Track payment intent
                                subscribeTo('EVALUATE')
                            }}
                            variant={'solid'}
                            className={'rounded-3xl font-bold text-sm w-fit pl-10 pr-10 self-center mt-4'}
                            color={'secondary'}
                            isDisabled={loading}
                        >
                            {!currentLimitations?.isFreeTrial && currentLimitations?.freeTrialPackage && currentLimitations?.freeTrialPackage === 'EVALUATE' ? 'Continue With EVALUATE' : 'Get Started'}
                        </Button>
                    </div>

                    <div className={'flex flex-col flex-1 border border-3 rounded-2xl border-default p-4'}>
                        <span className={'text-xs font-bold text-default-400 pb-2'}>EXECUTE</span>
                        <h3 className={'text text-3xl font-bold'}>$ 99</h3>
                        <h4 className={'text text-l font-bold'}>per user per month</h4>
                        <span className={'font-medium text-default-400 text-xs pb-4'}>Free 1-week trial, cancel anytime</span>

                        <span className={'font-medium text-sm'}>Monitor tenders</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Analyze fit & risks</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI tender monitoring
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Automatic email notifications
                            </li>
                        </ul>
                        <hr className='w-[80%] self-center' />
                        <span className={'font-medium text-sm pt-2'}>Create & manage proposals</span>
                        <ul className="list-inside list-none text-md font-light text-black pb-2">
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> AI-assisted proposal drafting
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Microsoft Word integrationm
                            </li>
                            <li className={'flex flex-row items-center gap-1 mb-1'}>
                                <Icon className={'text-secondary'} icon="lucide:check" /> Team workspace & audit logs
                            </li>
                        </ul>

                        <Button
                            onClick={() => {
                                // Track payment intent
                                subscribeTo('EXECUTE')
                            }}
                            variant={'solid'}
                            className={'rounded-3xl font-bold text-sm w-fit pl-10 pr-10 self-center mt-4'}
                            color={'secondary'}
                            isDisabled={loading}
                        >
                            {!currentLimitations?.isFreeTrial && currentLimitations?.freeTrialPackage && currentLimitations?.freeTrialPackage === 'EXPLORE' ? 'Continue with EXECUTE' : 'Get Started'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}